import axiosWithAuth from '@/utils/axiosWithAuth';

export interface G2ReviewSession {
  reviewUrl: string;
}

const createG2ReviewSession = async (): Promise<G2ReviewSession> => {
  const {data} = await axiosWithAuth.post<G2ReviewSession>('/g2_review');

  return data;
};

export default createG2ReviewSession;
